import moment from "moment";
import React, { Fragment, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import AnnouncementListLoader from "@/Components/common/AnnouncementListLoader";
import FilledLatestAnnouncementIcon from "@/Components/Icons/FilledLatestAnnouncementIcon";
import LatestAnnouncementIcon from "@/Components/Icons/LatestAnnouncementIcon";
import { fetchClientAllAnnouncementListData } from "@/reducers/clientAnnouncement";

import AnnouncementReadMoreWrapper from "./AnnouncementReadMoreWrapper";
import NoAnnouncementFound from "./NoAnnouncementFound";

const LatestAnnouncementList = () => {
  // const [isLoading, setLoading] = useState(false);
  const { clientAnnouncements, isLoading, clickViewMoreAnnouncementId } =
    useSelector((state) => state.clientAnnouncement);
  const dispatch = useDispatch();
  const dataTableRef = useRef();

  const handleTableScroll = (e) => {
    let element = e.target;
    let scrollHeight = element.scrollHeight;
    let scrollTop = element.scrollTop;
    let clientHeight = element.clientHeight;

    if (scrollHeight - scrollTop - clientHeight < 1.5) {
      dispatch(fetchClientAllAnnouncementListData({}));

      // dispatch(fetchApplicantLists({}));
    }
  };
  useEffect(() => {
    if (dataTableRef.current) {
      var $table = dataTableRef.current.querySelector(
        "._announcementLazyLoading",
      );
      $table.addEventListener("scroll", function (e) {
        handleTableScroll(e);
      });
    }
  }, []);

  const stripHtmlTags = (html) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  };

  return (
    <div className="latestAnnouncementList_Wrapper mb-[52px]">
      <div className="flex h-full flex-col rounded-[10px] bg-white p-4 shadow-[0px_x1px_6px_0px_#E7EFFB]">
        <div className="mb-[20px] flex flex-col flex-wrap gap-3 border-b border-b-[#E8E8E8] pb-[11px] md:flex-row md:items-center md:justify-between">
          <h4 className="text-[20px] font-semibold leading-[normal] text-black">
            Announcements
          </h4>
        </div>
        <div ref={dataTableRef} className="_announcementLazyLoading">
          <div
            className={`custom-scrollbar-ui _announcementLazyLoading flex w-full flex-col gap-4 ${isLoading ? "!overflow-y-hidden" : "!overflow-y-auto"} max-h-[570px]`}
          >
            {isLoading ? (
              Array.from({ length: 4 }).map((_, index) => (
                <Fragment key={index}>
                  <AnnouncementListLoader />
                </Fragment>
              ))
            ) : (
              <div className="DataTable_Wrapper hide_extended_arrow grid gap-4 pr-4">
                {clientAnnouncements.length > 0 ? (
                  clientAnnouncements.map((data, index) => (
                    <Fragment key={index}>
                      <div
                        className={`group grid w-full gap-4 rounded-lg border border-[#E9F1FD] p-4 transition-all duration-300 hover:bg-grey ${data?.announcement_id == clickViewMoreAnnouncementId ? "group bg-grey" : "group bg-white"}`}
                        key={index}
                      >
                        <div className="flex items-start gap-3">
                          <div className="rounded-lg bg-grey p-2 transition-all duration-300 group-hover:bg-primary">
                            <LatestAnnouncementIcon
                              cls={`h-[26px] w-[26px] text-primary  group-hover:hidden`}
                            />
                            <FilledLatestAnnouncementIcon
                              cls={`pr-[3.8px] h-[26px] w-[26px] hidden group-hover:block !text-white`}
                            />
                          </div>
                          <div className="flex flex-col gap-1">
                            <p className="text-Base text- line-clamp-1 font-semibold capitalize">
                              {moment(data.created_at).format("LL")}
                            </p>
                            <p className="text-[14px] font-medium leading-[normal] text-txtColor">
                              {data.announcement_ref_no}
                            </p>
                            <AnnouncementReadMoreWrapper
                              cls="text-[14px] font-medium text-txtColor"
                              text={stripHtmlTags(data?.announcement_message)}
                              announcement_id={data?.announcement_id}
                              max={400}
                            />
                          </div>
                        </div>
                      </div>
                    </Fragment>
                  ))
                ) : (
                  <NoAnnouncementFound />
                )}
              </div>
            )}
          </div>
        </div>
      </div>{" "}
      {/*main bg-white div  */}
    </div>
  );
};

export default LatestAnnouncementList;
